// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3CTNz","productName":"Table_productName__3_m4D"};